import { AppHTTPService } from '../http-service'

export interface PersonalAccessToken {
  id: string
  name: string
  createdAt: string
  lastUsedAt?: string | null
  actorId?: string
  pk?: number
  updatedAt?: string
}

export interface PersonalAccessTokensResponse {
  data: PersonalAccessToken[]
  pagination: {
    currentPage: number
    totalCount: number
    pageCount: number
  }
}

export interface CreatePersonalAccessTokenResponse {
  id: string
  name: string
  createdAt: string
  lastUsedAt?: string | null
  token: string
}

export const listPersonalAccessTokens = async (): Promise<PersonalAccessTokensResponse> => {
  const response = await AppHTTPService.axios.get('/v1/auth/personal-access-tokens')
  return response.data
}

export const createPersonalAccessToken = async (name: string): Promise<CreatePersonalAccessTokenResponse> => {
  const response = await AppHTTPService.axios.post('/v1/auth/personal-access-tokens', { name })
  return response.data.data
}

export const deletePersonalAccessToken = async (accessTokenId: string): Promise<void> => {
  await AppHTTPService.axios.delete(`/v1/auth/personal-access-tokens/${accessTokenId}`)
}
